import React from 'react';
import { HelperText, Regular, MediumPrimaryButton } from '@worthy-npm/clarity';
import { isMobile, goTo } from '../filters/filter_constants_and_helpers.jsx.erb';
import {pushGAEvent} from "../../common/helpers";
import { post } from '../../services/api';

class ItemLinkSticky extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        pushGAEvent('Recent deals', 'Sell ring sticky presented', 'Item link sticky')
        post(`/api/recent_deals/log_user_action`, {item_id: this.props.item_props.id, comment:'Sell ring sticky presented'})
    }

    render() {
        const mobile = isMobile()
        
        const style = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: mobile? "7px 12px" : "12px 18px",
            background: "#FFFFFF",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.08)",
            borderRadius: "4px",
            border: "1px solid #F2F2F2"
        }

        const cssOverride = {
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: window.innerWidth - 130 + "px"
        }

        return (
            <div style={style}>
                <div style={{display:"flex", flexDirection: 'column'}}>
                    <HelperText text="Your ring:"/>
                    <Regular bold={true} overrideCSS={cssOverride} text={this.props.item_props.desc}/>
                </div>
                <div data-automation='recent-deals-sticky-cta'>
                    <MediumPrimaryButton text={mobile? "Sell": "Sell Your Ring"} disableAnimation={mobile} click={()=>{
                        post(`/api/recent_deals/log_user_action`, {item_id: this.props.item_props.id, comment:'Sell ring sticky clicked'}).then(() => {
                            pushGAEvent('Recent deals', 'Sell ring sticky clicked', 'Item link sticky')
                            goTo(this.props.item_props.app_item_url)
                        })}}/>
                </div>
            </div>
        )
    }
}
export default ItemLinkSticky;
